<template>
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex align-items-center flex-wrap">
        <h1>Hava proqnozu:</h1>

        <select v-model="city" @change="changeCity">
          <option value="Bakı">Bakı</option>
          <option value="Ağcabǝdi">Ağcabǝdi</option>
          <option value="Ağdam">Ağdam</option>
          <option value="Ağdaş">Ağdaş</option>
          <option value="Ağstafa">Ağstafa</option>
          <option value="Ağsu">Ağsu</option>
          <option value="Astara">Astara</option>
          <option value="Balakən">Balakən</option>
          <option value="Beyləqan">Beyləqan</option>
          <option value="Bərdə">Bərdə</option>
          <option value="Biləsuvar">Biləsuvar</option>
          <option value="Cəlilabad">Cəlilabad</option>
          <option value="Daşkəsən">Daşkəsən</option>
          <option value="Gədəbəy">Gədəbəy</option>
          <option value="Gəncə">Gəncə</option>
          <option value="Goranboy">Goranboy</option>
          <option value="Göyçay">Göyçay</option>
          <option value="Göygöl">Göygöl</option>
          <option value="Horadiz">Horadiz</option>
          <option value="İmişli">İmişli</option>
          <option value="İsmayıllı">İsmayıllı</option>
          <option value="Laçın">Laçın</option>
          <option value="Lerik">Lerik</option>
          <option value="Lənkəran">Lənkəran</option>
          <option value="Masallı">Masallı</option>
          <option value="Mingəçevir">Mingəçevir</option>
          <option value="Naftalan">Naftalan</option>
          <option value="Naxçıvan">Naxçıvan</option>
          <option value="Oğuz">Oğuz</option>
          <option value="Şuşa">Şuşa</option>
          <option value="Qax">Qax</option>
          <option value="Qazax">Qazax</option>
          <option value="Qəbələ">Qəbələ</option>
          <option value="Qızılağac">Qızılağac</option>
          <option value="Quba">Quba</option>
          <option value="Qusar">Qusar</option>
          <option value="Saatlı">Saatlı</option>
          <option value="Sabirabad">Sabirabad</option>
          <option value="Sumqayıt">Sumqayıt</option>
          <option value="Şamaxı">Şamaxı</option>
          <option value="Şəki">Şəki</option>
          <option value="Şəmkir">Şəmkir</option>
          <option value="Siyəzən">Siyəzən</option>
          <option value="Tərtər">Tərtər</option>
          <option value="Tovuz">Tovuz</option>
          <option value="Ucar">Ucar</option>
          <option value="Khankendi">Xankəndi</option>
          <option value="Xaçmaz">Xaçmaz</option>
          <option value="Xudat">Xudat</option>
          <option value="Xırdalan">Xırdalan</option>
          <option value="Yalama">Yalama</option>
          <option value="Yardımlı">Yardımlı</option>
          <option value="Zaqatala">Zaqatala</option>
          <option value="Zərdab">Zərdab</option>
          <option value="Zangilan">Zəngilan</option>
        </select>

      </div>
    </div>

    <div class="spinner" v-if="loading"><div></div><div></div><div></div></div>

    <transition-group tag="div" appear name="fade" mode="out-in" v-else>
      <div class="row" :key="1">
        <div class="col-md-6" v-for="(day, dayIndex) in weather" :key="dayIndex + 0">

          <h2>{{ day[0].dt | unixDate }}</h2>
          <div class="item-main d-flex justify-content-around">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <img :src="'static/weather/' + day[0].weather[0].icon + '.svg'" class="big-icon">
              <div class="temp">{{ (day[0].main.temp).toFixed() }} &deg;C</div>
            </div>
            <div class="d-flex flex-column align-items-start justify-content-around">
              <div class="d-flex align-items-center">
                <img src="static/weather/wind.svg" alt="Külək" title="Külək" class="small-icon">
                {{ day[0].wind.speed | kmh }} km/saat
              </div>
              <div class="d-flex align-items-center">
                <img src="static/weather/drops.svg" alt="Rütubət" title="Rütubət" class="small-icon">
                {{ day[0].main.humidity }} %
              </div>
              <div class="d-flex align-items-center">
                <img src="static/weather/bar.svg" alt="Atmosfer təzyiqi" title="Atmosfer təzyiqi" class="small-icon">
                {{ day[0].main.pressure | pressure }} mm
              </div>
            </div>
          </div>

          <div class="item-second d-flex align-items-center justify-content-around">
            <div v-for="(time, timeIndex) in day" :key="timeIndex">
              <div class="time">
                {{ time.dt | unixTime }}
              </div>
              <div class="icon">
                <img :src="'static/weather/' + time.weather[0].icon + '.svg'" class="small-icon">
              </div>
              <div class="temp">
                {{ (time.main.temp).toFixed() }} &deg;C
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition-group>

  </div>
</template>

<script> 

  import axios from 'axios';

  export default {
    data(){
      return {
        loading: false,
        weather: [],
        city: 'Bakı',
        url: ''
      }
    },
    mounted(){
      this.createURL();
      this.getWeather();
    },
    methods: {
      getWeather: function(){

        this.loading = true;
        axios.get(this.url)
          .then(response => {
            
            this.loading = false;

            // Создаем даты
            let d0 = new Date(), 
                d1 = new Date(), 
                d2 = new Date(), 
                d3 = new Date(), 
                d4 = new Date(), 
                d5 = new Date(); 

            d1.setDate(d0.getDate() + 1);
            d2.setDate(d0.getDate() + 2);
            d3.setDate(d0.getDate() + 3);
            d4.setDate(d0.getDate() + 4);
            d5.setDate(d0.getDate() + 5);

            // Обнуляем значения в массиве
            this.weather = [];

            // Создаем массивы значений
            let day0 = [], day1 = [], day2 = [], day3 = [], day4 = [], day5 = [];

            for(let i = 0; i < response.data.list.length; i++ ){
              
              let day = new Date(response.data.list[i].dt * 1000).getDate();

              if(day === d0.getDate()){
                day0.push(response.data.list[i]);
              } else if(day === d1.getDate()){
                day1.push(response.data.list[i]);
              } else if(day === d2.getDate()){
                day2.push(response.data.list[i]);
              } else if(day === d3.getDate()){
                day3.push(response.data.list[i]);
              } else if(day === d4.getDate()){
                day4.push(response.data.list[i]);
              } else if(day === d5.getDate()){
                day5.push(response.data.list[i]);
              }
            }

            // Если массив не пустой, добавляем значения
            if(day0.length) {
              this.weather.push(day0);
            }
            if(day1.length) {
              this.weather.push(day1.splice(2, 8));
            }
            if(day2.length) {
              this.weather.push(day2.splice(2, 8));
            }
            if(day3.length) {
              this.weather.push(day3.splice(2, 8));
            }
            if(day4.length) {
              this.weather.push(day4.splice(2, 8));
            }
            if(day5.length) {
              this.weather.push(day5);
            }

          })
          .catch(error => {
            this.loading = true;
            console.log(error);
          });
      },
      createURL: function(){
        this.url = 'https://api.openweathermap.org/data/2.5/forecast?q=' 
                    + this.city 
                    + ',az&units=metric&appid=edb391dcff7bb6676c94925cc9044821';
      },
      changeCity: function(){
        this.createURL();
        this.getWeather();
      }
    },
    filters: {
      unixDate: function(value) {
        let a = new Date(value * 1000);
        let year = a.getFullYear();
        let monthName = ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avgust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr']
        let month = a.getMonth();
        let date = a.getDate();
        return (date + ' ' + monthName[month]);
      },
      unixTime: function(value) {
        let a = new Date(value * 1000);
        let date = a.getDate();
        let hour = a.getHours();
        let minute = '0' + a.getMinutes();
        return (hour + ':' + minute );
      },
      kmh: function(value) {
        return (value * 3.6).toFixed(0);
      },
      pressure: function(value) {
        return (value / 1.33322387415).toFixed(0);
      }
    }
    
  }
</script>

<style scoped>

select {
  margin-left: 2rem;
  max-width: 200px;
}
h2 {
  margin-top: 3rem;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}
.item-main {
  padding: 1rem;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
  background: #FFF;
  text-align: center;
  color: #333;
  font-size: 0.9rem;
  border-radius: 5px;
  border-bottom: 2px solid #eee;
}
img.big-icon {
  width: 50px;
  height: 50px;
}
img.small-icon {
  width: 20px;
  height: 20px;
}
.item-main img.small-icon {
  margin-right: 1rem;
}
.item-main .temp {
  font-size: 2.2rem;
  font-weight: bold;
  color: #036;
}

.item-second {
  padding: 1rem;
  text-align: center;
  border-radius: 5px;
  border-top: 2px solid #eee;
  background: #FAFAFA;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
  font-size: 0.9rem;
}
.item-second .time {
  color: #888;
}
.item-second .temp {
  font-weight: bold;
  color: #555;
}



@media only screen and (max-width: 768px) {
  select {
    margin-left: 0;
    max-width: 100%;
  }
  h2 {
    margin-top: 1rem;
    text-align: center;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/calc/Weather.vue